import React from 'react';
// import { Prompt } from 'react-router';

// TODO: IT DOES NOT WORK!
export class LeavePrompt extends React.Component {

  componentDidMount() {
    window.onbeforeunload = function(e) {
      const {dirty, message} = this.props;
      if (dirty) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    }.bind(this);
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  render() {

    // temporarily disable the prompt pop-up on the route switch,
    // and leave only the pop-up on the tab close or refresh.
    // TODO: there is a problem with the redirects in main menu and the prompt pop-up which need to be investigated in future

    // const {dirty, message} = this.props;
    // return <Prompt when={dirty} message={message}/>

    return null;
  }
}

export default LeavePrompt;
